import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap"; // Added Button
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';

const initialFieldValues = {
    customerId: '00000000-0000-0000-0000-000000000000',
    name: '',
    phone: '',
    email: '',
    address: '',
    createdAt: ''
};

const Customer = () => {
    const navigate = useNavigate();

    const [lists, setLists] = useState([]);
    const [btnLoading, setBtnLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const THEME_COLOR = '#065f46';

    const GetData = async (pNum) => {
    try {
        const res = await axios.get(config.APIACTIVEURL + config.GETCUSTOMER, {
            params: { pageSize: pageSize, pageNumber: pNum }
        });

        console.log("API Response:", res.data); // ADD THIS LOG TO SEE DATA

        if (res.data) {
            // If your API returns the list directly, use res.data
            // If it's wrapped in a 'data' property, use res.data.data
            const result = Array.isArray(res.data) ? res.data : res.data.data;
            setLists(result || []);
            
            setTotalPages(res.data.totalPages || 0);
            setTotalRecords(res.data.totalRecords || 0);
        }
    } catch (error) {
        console.error("Error fetching customers", error);
    }
};

    useEffect(() => {
        GetData(pageNumber);
    }, [pageNumber]);

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        setValues({ ...values, [name]: type === 'checkbox' ? checked : value });
    };

    const validate = () => {
        let temp = {};
        temp.name = values.name ? "" : "Customer Name is required";
        temp.email = (/$^|.+@.+..+/).test(values.email) ? "" : "Email is not valid";
        setErrors(temp);
        return Object.values(temp).every(x => x === "");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnLoading(true);
            try {
                const isNew = values.customerId === "00000000-0000-0000-0000-000000000000";

                if (isNew) {
                    await axios.post(config.APIACTIVEURL + config.CREATECUSTOMER, values);
                } else {
                    await axios.put(config.APIACTIVEURL + config.UPDATECUSTOMER, values);
                }

                setShowModal(false);
                resetForm();
                GetData(pageNumber);
            } catch (error) {
                console.error("Save failed", error);
            } finally {
                setBtnLoading(false);
            }
        }
    };

    const handleDelete = async () => {
        if (itemToDelete) {
            try {
                // FIXED: Added APIACTIVEURL
                await axios.delete(`${config.APIACTIVEURL}${config.DELETECUSTOMER}/${itemToDelete}`);
                setShowDeleteModal(false);
                GetData(pageNumber);
            } catch (error) {
                console.error("Delete failed", error);
            }
        }
    };

    const handleEdit = (customer) => {
        setValues(customer);
        setShowModal(true);
    };

    const resetForm = () => {
        setValues(initialFieldValues);
        setErrors({});
    };

    return (
        <div className="page-content" style={{ paddingTop: "80px" }}>
            <div className="container-fluid py-4">
                <div className="card border-0 shadow-sm rounded-4">
                    <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                        <h4 className="fw-bold mb-0" style={{ color: '#064e3b' }}>Customers</h4>
                        <button className="btn text-white fw-bold px-4 shadow-sm"
                            style={{ backgroundColor: THEME_COLOR }}
                            onClick={() => { resetForm(); setShowModal(true); }}>
                            <i className="ri-add-line me-1"></i> Add New Customer
                        </button>
                    </div>

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle">
                                <thead className="table-light">
                                    <tr className="text-secondary small text-uppercase">
                                        <th>Customer Name</th>
                                        <th>Phone</th>
                                        <th>Email</th>
                                        <th>Address</th>
                                        <th>Created At</th>
                                        <th className="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lists.map((item) => (
                                        <tr key={item.customerId}>
                                            <td className="fw-bold text-dark">{item.name}</td>
                                            <td>{item.phone}</td>
                                            <td>{item.email}</td>
                                            <td>{item.address}</td>
                                            <td>{item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A'}</td>
                                            <td className="text-center">
                                                <button className="btn btn-sm btn-outline-primary border-0 me-2" onClick={() => handleEdit(item)}>
                                                    <i className="ri-pencil-line fs-5"></i>
                                                </button>
                                                <button className="btn btn-sm btn-outline-danger border-0"
                                                    onClick={() => { setItemToDelete(item.customerId); setShowDeleteModal(true); }}>
                                                    <i className="ri-delete-bin-line fs-5"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* FORM MODAL */}
                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
                    <Modal.Header closeButton className="border-0">
                        <Modal.Title className="fw-bold">
                            {/* FIXED: changed salonId to customerId */}
                            {values.customerId === "00000000-0000-0000-0000-000000000000"
                                ? 'Register New Customer'
                                : 'Edit Customer Details'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4">
                        <form className="row g-3" onSubmit={handleSubmit}>
                            <div className="col-md-6">
                                <label className="form-label small fw-bold text-muted">Customer Name</label>
                                <input type="text" name="name" value={values.name} onChange={handleInput} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small fw-bold text-muted">Phone Number</label>
                                <input type="tel" name="phone" value={values.phone} onChange={handleInput} className="form-control" />
                            </div>
                            <div className="col-md-12">
                                <label className="form-label small fw-bold text-muted">Email Address</label>
                                <input type="email" name="email" value={values.email} onChange={handleInput} className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </div>
                            <div className="col-12">
                                <label className="form-label small fw-bold text-muted">Address</label>
                                <textarea name="address" value={values.address} onChange={handleInput} className="form-control" rows="2" />
                            </div>
                            <div className="modal-footer border-0 p-0 mt-4">
                                <button type="button" className="btn btn-light px-4 fw-bold" onClick={() => setShowModal(false)}>Cancel</button>
                                <button type="submit" disabled={btnLoading} className="btn text-white px-5 fw-bold shadow-sm" style={{ backgroundColor: THEME_COLOR }}>
                                    {btnLoading ? 'Processing...' : (values.customerId === "00000000-0000-0000-0000-000000000000" ? 'Save Customer' : 'Update Changes')}
                                </button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>

                {/* FIXED: ADDED DELETE MODAL UI */}
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this customer? This action cannot be undone.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                        <Button variant="danger" onClick={handleDelete}>Delete Permanently</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default Customer;
